module.exports = __webpack_public_path__ + "static/img/teacher8.bb9a7f8a.png";